import {
	mdiBellOutline,
	mdiCreditCardOutline,
	mdiHeadphonesSettings,
	mdiHome,
	mdiMessage,
	mdiNewspaperVariantMultipleOutline,
	mdiRocketLaunchOutline,
	mdiHandshakeOutline,
	mdiViewListOutline,
	mdiTrophyOutline,
	mdiViewGridOutline,
	mdiCashMultiple,
	mdiCalendarClock,
} from '@mdi/js'

// Array of sections

export default [
	{
		icon: mdiHome,
		title: 'Dashboard',
		to: 'tv-dashboard',
	},
	{
		title: 'categories',
		icon: mdiViewListOutline,
		module: 'MGTV,categories',
		children: [
			{
				title: 'categories',
				to: 'tv-categories-list',
			},
			{
				title: 'subCategories',
				to: 'tv-subcategories-list',
			},
		],
	},
	{
		title: 'Agenda',
		icon: mdiCalendarClock,
		module: 'MGTV,streamers',
		to: 'tv-agenda-week',
	},
	{
		title: 'Streamers',
		icon: mdiHeadphonesSettings,
		module: 'MGTV,streamers',
		children: [
			{
				title: 'Streamers',
				to: 'tv-streamers-list',
			},
			{
				title: 'menu.tv.streamersTypes',
				to: 'tv-streamers-types-list',
			},
			{
				title: 'menu.tv.streamersApplications',
				to: 'tv-streamers-applications-list',
			},
		],
	},
	{
		title: 'Subscribers',
		icon: mdiCreditCardOutline,
		to: 'tv-subscriptions-list',
		module: 'MGTV,subscribers',
	},
	{
		title: 'Sponsorships',
		icon: mdiHandshakeOutline,
		module: 'MGTV,sponsorships',
		children: [
			{
				title: 'Campaigns',
				to: 'tv-sponsorships-campaigns-list',
			},
			{
				title: 'Applications',
				to: 'tv-sponsorships-applications-list',
			},
		],
	},
	{
		title: 'Boosts',
		icon: mdiRocketLaunchOutline,
		to: 'tv-boosts-list',
		module: 'MGTV,boosts',
	},
	{
		title: 'Gamification',
		icon: mdiTrophyOutline,
		children: [
			{
				title: 'Missions',
				to: 'gamification-missions-list',
			},
			{
				title: 'Achievements',
				to: 'gamification-achievements-list',
			},
			{
				title: 'Reward Rules',
				to: 'gamification-reward-rules-list',
			},
			{
				title: 'Referral Reward Tiers',
				to: 'referrals-reward-tiers-list',
			},
			{
				title: 'Referral Conversions',
				to: 'referrals-conversions-list',
			},
		],
	},
	{
		icon: mdiViewGridOutline,
		title: 'Indie Walls',
		module: 'MGTV,streamers',
		children: [
			{
				title: 'Murais',
				to: 'tv-walls-list',
			},
			{
				title: 'Saques',
				to: 'tv-walls-payouts',
			},
		],
	},
	{
		icon: mdiMessage,
		title: 'menu.messages',
		to: 'tv-messages-list',
		module: 'MGTV,messages',
	},
	{
		icon: mdiNewspaperVariantMultipleOutline,
		title: 'Newsletter',
		to: 'tv-newsletter-list',
		module: 'MGTV,newsletter',
	},
	{
		icon: mdiBellOutline,
		title: 'notifications.notifications',
		module: 'MGTV,notifications',
		children: [
			{
				title: 'menu.notifications.list',
				to: 'tv-notifications-list',
			},
			{
				title: 'menu.notifications.templates',
				to: 'network-notification-templates-list',
			},
		],
	},
]
